/**
 * Whether to show the performance readout, asked for with `?perf=1`.
 *
 * Erasing felt slow on a phone in a way that nothing measurable from a desktop
 * browser could reproduce — twice the cost turned out to be somewhere a page
 * cannot see it from the inside. The readout exists so a number can come off
 * the device itself rather than being inferred from a description.
 */
export const isPerfEnabled = (search: string = window.location.search): boolean =>
  new URLSearchParams(search).get("perf") === "1";

/** The value at `fraction` through a set of samples, smallest first. */
export const percentile = (samples: readonly number[], fraction: number): number => {
  if (samples.length === 0) return 0;
  const sorted = [...samples].sort((a, b) => a - b);
  const index = Math.min(sorted.length - 1, Math.floor(sorted.length * fraction));
  return Math.round(sorted[index]);
};
